package demos.counter

import androidx.compose.animation.core.Animatable
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.launch

@Composable
fun CounterButton(
    sign: String,
    onClick: () -> Unit
) {

    val scale = remember { Animatable(1f) }
    val scope = rememberCoroutineScope()

    Box(
        Modifier
            .padding(12.dp)
            .scale(scale.value)
            .size(32.dp)
            .clip(CircleShape)
            .background(Color(0xffff8a50))
            .clickable {
                scope.launch {
                    scale.animateTo(.8f)
                    scale.animateTo(1f)
                }
                onClick()
            },
        contentAlignment = Alignment.Center
    ) {
        Text(sign, fontSize = 18.sp, fontWeight = FontWeight.Bold, color = Color.Black)
    }
}